import { Button } from '@/components/shadcn/button'
import { CollapsibleFilterContainer } from '@/components/ui/CollapsibleFilterContainer'
import { useMemo, useState } from 'react'
import { SearchInput } from '../../component-library/shared/SearchInput'
import { TemplatesAccordion } from './TemplatesAccordion'
import { TemplatesFilter } from './TemplatesFilter'
import { useGetTemplatesSummary } from './useGetTemplatesSummary'
import { filterTemplates, groupTemplateItems } from './utils'
import { IconV2RotateClockwiseOutline } from '@icons/IconV2RotateClockwiseOutline'
export function TemplatesV2() {
  const { data: summary, refetch } = useGetTemplatesSummary({})
  const [filter, setFilter] = useState<string>('All')
  const [search, setSearch] = useState<string>('')
  const filteredSummary = useMemo(() => filterTemplates(summary, filter, search), [filter, search, summary])
  const groupedAndFilteredSummary = useMemo(() => groupTemplateItems(filteredSummary), [filteredSummary])
  return (
    <>
      <div className="sticky top-0 flex w-full items-center justify-between bg-background/50 py-2 backdrop-blur">
        <SearchInput value={search} onChange={setSearch} />
        <div className="flex items-center gap-x-2">
          <CollapsibleFilterContainer>
            <TemplatesFilter filter={filter} setFilter={setFilter} />
          </CollapsibleFilterContainer>
          <Button variant="ghost" size="icon" onClick={() => refetch()}>
            <IconV2RotateClockwiseOutline size={20} />
          </Button>
        </div>
      </div>
      <TemplatesAccordion summary={groupedAndFilteredSummary} />
    </>
  )
}
